(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["personalizacao-produto-block"] && !Shopify.designMode) return;
  try {
    class PersonalizacaoProdutoBlock extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('input[maxlength], textarea[maxlength]').forEach(input => {
        const counter = this.querySelector(`[data-for="${input.id}"]`);
        if (!counter) return;
        input.addEventListener('input', () => {
          counter.textContent = `${input.value.length}/${input.maxLength}`;
        });
      });
    }
  }

  if (!customElements.get('personalizacao-produto-block')) {
    customElements.define('personalizacao-produto-block', PersonalizacaoProdutoBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
